import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress page — permanently redirect to the blog rollup.
export const Route = createFileRoute("/hair-cloning-follicle-banking")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/hair-loss-blog/", location.searchStr), statusCode: 301 });
  },
});
